import { Deck } from "../models/deck";
import { IntroQuest } from "../cards/quest/quests";
export class Quest extends Deck {
}
Quest.displayName = "Quests";
Quest.artUrl = "./assets/decks/quests.jpg";
Quest.initialCards = [IntroQuest];
